export function SidebarBrand() {
  return (
    <div className="flex items-center gap-2.5 border-b border-white/5 px-6 py-5">
      <div className="grid h-[30px] w-[30px] grid-cols-2 gap-1">
        <span className="h-3 w-3 rounded-[1px] bg-white" />
        <span className="h-3 w-3 rounded-[1px] bg-white" />
        <span className="h-3 w-3 rounded-[1px] bg-white" />
        <span className="h-3 w-3 rounded-full bg-brand" />
      </div>
      <div className="flex flex-col leading-none">
        <span className="text-lg font-extrabold tracking-tight text-white">
          Teco<span className="text-brand">POS</span>
        </span>
        <span className="mt-0.5 inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/45">
          Portal
          <span className="rounded bg-white/10 px-1 py-px text-[9px] font-bold tracking-normal text-white/70">v{__APP_VERSION__}</span>
        </span>
      </div>
    </div>
  )
}
